// src/pages/LeaderboardRedirect.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function LeaderboardRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // signal App to open the leaderboard modal once
    localStorage.setItem("openLeaderboardOnce", "1");
    navigate("/", { replace: true });
  }, [navigate]);

  return null; // nothing to render
}
